import ESigningFormBase from './ESigningFormBase';
import ESigningFormDefault from './forms/ESigningFormDefault';
import ESigningFormPremiumAgreement from './forms/ESigningFormPremiumAgreement';
import ESigningFormCombinedPremiumAgreement from './forms/ESigningFormCombinedPremiumAgreement';
import ESigningFormDatepicker from './ESigningForm.datepicker';

/**
 * Entry point for the E-Signing Agreement Form.
 *
 * Initializes the shared base (steps 2+3, navigation, templates, receivers)
 * and listens for the `esigning:formloaded` event to dynamically load the
 * correct step-1 variant class based on the selected template's FormType.
 */
export default class ESigningForm {
    constructor() {
        if (document.getElementsByClassName('esigning-agreement').length < 1) {
            return;
        }

        this.base = new ESigningFormBase();

        document.addEventListener('esigning:formloaded', (evt) => {
            const formType = evt.detail?.formType || 'Default';
            this._loadVariant(formType);
            // Ensure datepicker is always initialized after form partial reload
            ESigningFormDatepicker.init();
        });
    }

    /**
     * Load and instantiate the variant class for the given formType.
     * All variants are statically imported so Vite can bundle them.
     * @param {string} formType
     */
    _loadVariant(formType) {
        try {
            const variantMap = {
                'Default': ESigningFormDefault,
                'NaturePlus': ESigningFormPremiumAgreement,
                'FieldPeas': ESigningFormPremiumAgreement,
                'ClimateAndNature': ESigningFormPremiumAgreement,
                'Holl': ESigningFormPremiumAgreement,
                'Hear': ESigningFormPremiumAgreement,
                'ClimateAndNaturePlus': ESigningFormCombinedPremiumAgreement,
                // Add more variants here as needed
            };

            const VariantClass = variantMap[formType] || ESigningFormDefault;
            this.variant = new VariantClass(this.base);
        } catch (err) {
            console.error(`Failed to load form variant "${formType}", falling back to Default.`, err);
            this.variant = new ESigningFormDefault(this.base);
        }
    }
}
